module.exports = __webpack_public_path__ + "img/alipay-alternative3.83d7b5c4.png";